import { useCallback, useEffect, useState } from 'react'

import jwtSessionService from '@app/services/jwtSessionService'

import type { Session } from '@app/services/jwtSessionService/types'
import type { UseJwtSessionReturn } from './types'

export const useJwtSession = (): UseJwtSessionReturn => {
  const [session, updateSession] = useState<Session | null>(jwtSessionService.getSession())

  const handleSessionChange = (): void => {
    updateSession(jwtSessionService.getSession())
  }

  const getSession = useCallback((): Session | null => jwtSessionService.getSession(), [])

  const setSession = useCallback((session: Session): void => jwtSessionService.setSession(session), [])

  const clearSession = useCallback((): void => jwtSessionService.clearSession(), [])

  useEffect(() => {
    jwtSessionService.subscribeToSessionChange(handleSessionChange)

    return () => jwtSessionService.unsubscribeToSessionChange(handleSessionChange)
  }, [])

  return { session, getSession, setSession, clearSession }
}
